// 📄 components/ui/PasswordInput.tsx
// Input de contraseña genérico con toggle mostrar/ocultar. Pensado para
// reutilizarse en cualquier formulario que pida contraseña (login, registro,
// futuro CambiarPasswordObligatorio), por eso no incluye validación propia.
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface PasswordInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  id?: string;
  name?: string;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
  className?: string;
}

export default function PasswordInput({
  value,
  onChange,
  onBlur,
  placeholder = 'Contraseña',
  id,
  name,
  autoComplete,
  required,
  minLength,
  className = '',
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`relative ${className}`}>
      <input
        type={visible ? 'text' : 'password'}
        id={id}
        name={name}
        className="w-full p-2 pr-10 rounded bg-gray-700 text-white"
        placeholder={placeholder}
        aria-label={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        tabIndex={-1}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
